import { IconButton } from "@/Common/Components/IconControls/IconControls";
import { IDirectoryEntity } from "@/ContactDirectory/Models/IDirectoryEntity";
import { DirectorySearchInfo } from "./DirectorySearchInfo";
import { DirectorySearchTitle } from "./DirectorySearchTitle";
import { IDirectoryEntityDisplayComponentProps } from "./FaxDirectorySearchComponent";
import { FaxDirectorySearchResultItem } from "./FaxDirectorySearchResultItem";

import styles from "./DirectorySearchResultItem.module.scss";

interface IDirectorySearchResultItemProps extends IDirectoryEntityDisplayComponentProps<IDirectoryEntity> {
    item: FaxDirectorySearchResultItem;
    disableEdit?: boolean;
    selectFaxNumber?: (faxNumberId: string) => void;
}

export function DirectorySearchResultItem(props: IDirectorySearchResultItemProps): JSX.Element {
    const entity = props.item?.entity;

    if (!entity)
        return null;

    const linkedEntities = entity.getLinkedDirectoryEntities();

    return (
        <div className={`${styles.subContainer} ${styles.itemContainer}`} key={entity.id}>
            {!props.disableEdit && (
                <IconButton
                    type="pen"
                    color="darkblue"
                    buttonClassName="float-right"
                    onClick={() => props.onEdit?.(entity)}
                />
            )}
            <DirectorySearchTitle
                searchResultItem={props.item}
                isSubItem={props.isSubItem}
                disableEdit={props.disableEdit}
            />
            <DirectorySearchInfo
                entity={entity}
                onSelectFaxNumber={faxNumberId => props.selectFaxNumber(faxNumberId)}
            />
            {linkedEntities.any() && linkedEntities.map((linkedEntity: IDirectoryEntity) => (
                <DirectorySearchResultItem
                    key={`${entity.id}_${linkedEntity.id}`}
                    item={new FaxDirectorySearchResultItem({ id: linkedEntity.id, entity: linkedEntity })}
                    isSubItem={true}
                    disableEdit
                />
            ))}
        </div>
    );
}
